const normalise = (field)=>typeof field === 'object' ? field : {
        name: field
    };
export function isCellValuePresent(row, column) {
    const value = row[column.name];
    if (value == null) return false;
    if (typeof value === 'string') return value !== '';
    if (Array.isArray(value)) return value.length > 0;
    return true;
}
export function columnsByName(columns) {
    return new Map(columns.map((column)=>[
            String(column.name),
            column
        ]));
}
export function toMobileCardFields(param) {
    let { byName, mobile } = param;
    return mobile.fields.flatMap((field)=>{
        const spec = normalise(field);
        const column = byName.get(String(spec.name));
        if (column == null) return [];
        return [
            {
                column,
                label: spec.label,
                hideColon: !!spec.hideColon,
                inline: !!spec.inline,
                spaceBetween: !!spec.spaceBetween,
                dividerBefore: !!spec.dividerBefore,
                emphasis: spec.emphasis
            }
        ];
    });
}
